<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    Pengaduan
                </div>
                <div class=""></div>
            </div>
        </div>
        <div class="wrapper" style="margin-left:0;margin-right:0;">
            <div class="ml10 mr10 mt10" v-show="get.data.loading">
                <div class="tulang">
                    <Loading style="height: 50px;" class="mb20">
                    </Loading>
                    <Loading style="height: 50px;" class="mb20">
                    </Loading>
                    <Loading style="height: 50px;" class="mb20">
                    </Loading>
                </div>
            </div>
            <div class="body bg-white pl10 pr10">
                <div v-for="(u, index) in get.data.list" class="bt-1">
                    <div class="box-horizontal pr10 pl10 pb10 pt10" @click="met.detail(u)">
                        <div class="flex-1">
                            <span class="block">Pengaduan #{{u.id}}</span>    
                            <small class="gray">{{myGlobal.tglIndo(u.tanggal)}} || {{u.jam}}</small>
                        </div>
                        <div>
                            <span v-if="u.status != 'selesai'" class="orange">Pending</span>
                            <span v-else class="green">Selesai</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    components: { 
        'Loading': Loading
    },
    setup() {
        const get = {
            data: reactive({
                this: '',
                list: [],
                loading: true
            }),
            list() {
                var datax = {
                    token: 'TangTung ' +sessionStorage.getItem('tokenu')
                };
            
                var apiUrl = inter.Pengaduan();

                myGlobal.call(datax,apiUrl).then(x => {
                    console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        this.data.list = x.data;
                        this.data.loading = false;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }
                })
            }
        }
        const met = {
            back() {
                window.history.back();
            },
            detail(x) {
                router.push({ 
                    name: 'pengaduan-detail', 
                    params: {
                        data: x
                    } 
                });
            }
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            met,
            get,
            redirectx,
            myGlobal
        }

    },
    mounted () {        
        this.redirectx.checkApp();

        this.get.list();
        
        //myGlobal.android("toast", myGlobal.androidGet("latlng") );
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Pengumuman/main.vue